export default __webpack_public_path__ + "static/media/meydan-free-zone.abac8008.png";